import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";


const features = [
    {
        title: "User-Friendly Interface",
        description: "Easily create, edit, and manage content without technical expertise.",
        imgUrl: "./img/services/crm-solutions/user-friendly-interface.jpg",
    },
    {
        title: "Customizable Templates",
        description: "Choose from a variety of templates to match your brand’s style.",
        imgUrl: "./img/services/crm-solutions/customizable-template.jpg",
    },
    {
        title: "Scalability",
        description: "Expand your website effortlessly as your business grows.",
        imgUrl: "./img/services/crm-solutions/scalability.jpg",
    },
    {
        title: "SEO Optimization Tools",
        description: "Leverage built-in SEO features to improve search engine rankings.",
        imgUrl: "./img/services/crm-solutions/seo.jpg",
    },
    {
        title: "Multi-User Collaboration",
        description: "Enable team members to contribute and manage content simultaneously.",
        imgUrl: "./img/services/crm-solutions/multi-user-collab.png",
    },
    {
        title: "Third-Party Integrations",
        description: "Integrate tools like CRMs, analytics, and eCommerce platforms.",
        imgUrl: "./img/services/crm-solutions/third-party-integrations.png",
    },
];


const CRMSolutions = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "CMS Solutions", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="CMS Solutions" description="Empower your business with intuitive content management systems designed to streamline your online presence." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is a CMS?</h2>
                            <p>
                                A Content Management System (CMS) is a software application that allows users to create, manage, and modify content on a website without needing specialized technical knowledge. It simplifies the process of managing digital content.
                            </p>
                            <img
                                src="./img/services/crm-solutions.jpg"
                                alt="CMS Solutions"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Our Key Services</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Popular CMS Platforms</h2>
                            <ul>
                                <li>
                                    <strong>WordPress:</strong> The most widely used CMS for blogs, portfolios, and small to medium-sized businesses.
                                </li>
                                <li>
                                    <strong>Drupal:</strong> Ideal for complex and enterprise-level websites requiring high customization.
                                </li>
                                <li>
                                    <strong>Joomla:</strong> A flexible CMS offering multilingual support and various extensions.
                                </li>
                                <li>
                                    <strong>Shopify:</strong> A leading eCommerce platform for online stores.
                                </li>
                                <li>
                                    <strong>Wix:</strong> Perfect for small businesses and individuals with drag-and-drop functionality.
                                </li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Start Managing Your Content with Ease</h2>
                            <p>
                                Discover the perfect CMS solution tailored to your business needs. <br />
                                Reach out to us at{" "}
                                <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default CRMSolutions;
